import { Navigate, Outlet, useNavigate } from "react-router-dom";
import Footer from "../Components/Common/Footer";
import Header from "../Components/Common/Header";

import Sidebar from "../Components/Common/Sidebar";
import { restrictUserRoutes } from "../Components/Utility/CheckAuth";
// import { restrictUserRoutes } from "../Components/Utility/CheckAuth";

function UserRoute() {
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();

  // If token not found, redirect to login page
  if (!token) {
    return <Navigate to="/" replace />;
  }

  const canAccess = restrictUserRoutes(navigate, 1);
  if (!canAccess) return <Navigate to="/" replace />;

  return (
    <>
      <Header />
      <div className="main-container pt-0">
        <div className="container">
          <div className="row">
            <Sidebar />
            <div className="col-lg-9">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default UserRoute;
